export const SET_IS_GLOBAL_DOWNLOADING = "SET_IS_GLOBAL_DOWNLOADING";
